import Navbar from '@/components/section/navbar/navbar';
import { AppSidebar } from '@/components/section/sidebar/AppSidebar';
import { SidebarProvider } from '@/components/ui/sidebar';
import useAuth from '@/hooks/useAuth';
import { Outlet } from 'react-router-dom';
import CallbackPage from './Callback';
import { Announcements } from '@/components/section/announcements-audience/AnnouncementsAudience';
import useGetUser from '@/hooks/queries/users-api/useGetUser';
import useGetOrganization from '@/hooks/queries/organization-api/useGetOrganization';
import useSocket from '@/hooks/useSocket';
import useGetChats from '@/hooks/queries/chat-api/useGetChats';
import { useEffect } from 'react';
import { useRootStore } from '@/stores/root-store';

const RootAsUserLogged = () => {
  const { isLoading: isLoadingUser } = useGetUser();
  const { data: organization, isLoading: isLoadingOrganization } =
    useGetOrganization();
  const isEnabledSocket = organization?.additionalData
    ? !!JSON.parse(organization?.additionalData).messages
    : false;

  const socket = useSocket({ enabled: isEnabledSocket });
  const { data } = useGetChats({ enabled: isEnabledSocket }); // TODO: Review the data fetching strategy for chats
  const setChats = useRootStore((state) => state.setChats);

  useEffect(() => {
    if (data && isEnabledSocket) {
      setChats(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  if (isLoadingUser || isLoadingOrganization) {
    return <CallbackPage />;
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="relative flex-1 overflow-y-auto">
        <Navbar />
        <div className="flex flex-col gap-4 p-4 mt-14 md:mt-[60px] md:px-6 md:py-6 bg-base-200">
          <Announcements />
          <div>
            <Outlet />
          </div>
        </div>
      </main>
    </SidebarProvider>
  );
};

const Root = () => {
  const { tokenIsPending } = useAuth();

  if (tokenIsPending) {
    return <CallbackPage />;
  }

  return <RootAsUserLogged />;
};
export default Root;
